enum UserFormDetails {
  placeOfWork = "Place of Work",
  empNumber = "Employee Number",
  niNumber = "Ni Number",
  title = "Title",
  dateOfBirth = "Date of Birth",
  firstName = "First Name",
  lastName = "Last Name",
  email = "Email",
  mobileNumber = "Mobile Number",
  addressLineOne = "Address Line One",
  addressLineTwo = "Address Line Two",
  town = "Town",
  county = "County",
  postCode = "Post Code"
}

enum UserTitle {
  mr = "Mr",
  mrs = "Mrs",
  ms = "Ms",
  miss = "Miss",
  dr = "Dr",
  prof = "Prof",
  rev = "Rev",
  mx = "Mx",
  noTitle = "No Title"
}

enum DOBLabel {
  day = "Day",
  month = "Month",
  year = "Year"
}

export {UserFormDetails, UserTitle, DOBLabel}
